<app-data-set
	#dataSet
	[dataSource]="dataSource"
	[rowId]="rowId"
	defaultPresentationMode="table"
	class="note-alerts"
	firstColumnProperty="deviceNote.note"
>
	<app-data-set-content>
		@if (dataSource.data.length !== 0) {
			<div class="notes-header">
				<h2 class="notes-title">
					<span data-automation-id="deviceNotes-deviceNotesHeader" i18n="@@deviceNotes-deviceNotesHeader"
						>Device Notes</span
					>
					<span class="no-weight-title">|</span>
					<span class="no-record weight-title">{{ noteTotals }}</span>
				</h2>
			</div>
		}
		@if (dataSource.data.length !== 0) {
			<div class="wrapper">
				@if (loadingService.isLoading(getAllDeviceNotesLoadingKey) || !finishedLoadingInitData) {
					<table class="loading-wrapper">
						<tr class="mat-row">
							<td class="mat-cell no-border">
								<mat-spinner diameter="25" style="float: left"></mat-spinner>
								<div style="float: left; margin-left: 1em" i18n="@@dataSetTable-loadingRecords">Loading records...</div>
							</td>
						</tr>
					</table>
				}
				<table mat-table [dataSource]="dataSource" matSort>
					<ng-container matColumnDef="photos">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceNotes-Photos" hidden>Photos</th>
						<td class="note-margin" mat-cell *matCellDef="let row">
							<div class="note-icon">
								@if (row.deviceNotePhotos.length === 0) {
									<div>
										<mat-icon class="device-no-note-icon" svgIcon="sl-document"></mat-icon>
									</div>
								} @else {
									<mat-icon
										class="device-note-icon"
										svgIcon="sl-image"
										[attr.data-automation-id]="'show-photos-' + row.id + '-button'"
										matTooltip="{{ notePhotosTooltip }}"
										(click)="showPhotos($event, row.deviceNotePhotos)"
									></mat-icon>
								}
							</div>
						</td>
					</ng-container>
					<ng-container matColumnDef="note">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceNotes-Notes-home" hidden>Notes</th>
						<td mat-cell *matCellDef="let row" class="notes-table-cell">
							<span class="subheading secondary-blue">{{ row.deviceNote.location }}</span>
							<span class="body-one light-secondary"> - {{ row.user.firstName }} {{ row.user.lastName }}</span> <br />
							<div class="light-secondary web-caption note-container">
								{{ row.deviceNote.note }}
							</div>
							<span class="web-caption light-tertiary"
								>{{
									row.deviceNote.utcEntryTime
										| date
											: 'shortTime'
											: timeZoneService.utcOffset(row.deviceNote.utcEntryTime, row.deviceNote.locationTimeZone)
								}}
								on
								{{
									row.deviceNote.utcEntryTime
										| date
											: 'shortDate'
											: timeZoneService.utcOffset(row.deviceNote.utcEntryTime, row.deviceNote.locationTimeZone)
								}}
								{{ row.deviceNote.locationTimeZone | shortNamedOffset }} -
								{{ formatNoteTypeDisplayName(row.deviceNote.noteType) }}</span
							>
						</td>
					</ng-container>
					<ng-container matColumnDef="deviceId">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceNotes-deviceId" hidden>DeviceId</th>
						<td mat-cell *matCellDef="let row" hidden>
							{{ row.deviceNote.deviceId }}
						</td>
					</ng-container>
					<ng-container matColumnDef="rowMenu">
						<th mat-header-cell *matHeaderCellDef hidden></th>
						<td mat-cell *matCellDef="let row" class="dismiss-icon-container">
							<mat-icon
								mat-button
								class="dismiss-icon"
								svgIcon="sl-dismiss"
								(click)="dismissNote($event, row.deviceNote)"
								[attr.data-automation-id]="'dismiss-note-' + row.id + '-button'"
							></mat-icon>
						</td>
					</ng-container>
					<tr mat-header-row *matHeaderRowDef="displayedColumns" class="no-height"></tr>
					<tr
						mat-row
						*matRowDef="let row; columns: displayedColumns"
						(click)="onRowClick(row)"
						[attr.data-automation-id]="'device-notes-home-' + row.id + '-row'"
					></tr>
				</table>
			</div>
		}

		@if (dataSource.data.length === 0) {
			<div class="no-records-wrapper">
				<span class="no-record" i18n="@@deviceNotes-noRecordsFound" data-automation-id="deviceNotes-noRecordsFound"
					>You're all caught up on note alerts.</span
				>
			</div>
		}

		<div class="paginator-container">
			@if (dataSource.data.length !== 0) {
				<mat-paginator
					#paginator
					(page)="handlePageEvent($event)"
					[length]="noteTotals"
					[pageSize]="pageSize"
					[pageSizeOptions]="pageSizeOptions"
					[pageIndex]="currentPage"
					data-automation-id="device-notes-pagination"
				>
				</mat-paginator>
			}
		</div>
	</app-data-set-content>
</app-data-set>
